// modules
import { createAction } from 'redux-actions'

export const setWaitingRoomList = createAction('SET_WAITING_ROOM_LIST')
export const setWaitingRoomLoading = createAction('SET_WAITING_ROOM_LOADING')

export const setUrgentCareCount = createAction('SET_URGENT_CARE_COUNT')
export const setUrgentCareUsers = createAction('SET_URGENT_CARE_USERS')

export const setUrgentCareDeclineReasons = createAction(
  'SET_URGENT_CARE_DECLINE_REASONS'
)

export const setUrgentCareUsersOnDuty = createAction(
  'SET_URGENT_CARE_USERS_ON_DUTY'
)
